import React from 'react';
import { DatePicker, Form, Switch, Typography } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { DEFAULT_TRIAL_DAYS } from '../utils/tenantStatus';

const { Text } = Typography;

export interface HostTenantLicenseFormValues {
  useDefaultTrial: boolean;
  licenseEndsAt?: Dayjs;
}

interface HostTenantLicenseFieldsProps {
  trialDays?: number;
}

const HostTenantLicenseFields: React.FC<HostTenantLicenseFieldsProps> = ({
  trialDays = DEFAULT_TRIAL_DAYS,
}) => {
  const useDefaultTrial = Form.useWatch<boolean>('useDefaultTrial');

  return (
    <>
      <Form.Item
        name="useDefaultTrial"
        label="Trial period"
        valuePropName="checked"
      >
        <Switch checkedChildren="Default trial" unCheckedChildren="Custom end date" />
      </Form.Item>
      {useDefaultTrial ? (
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          License ends {trialDays} days from today (configurable trial length).
        </Text>
      ) : (
        <Form.Item
          name="licenseEndsAt"
          label="License end date"
          rules={[{ required: true, message: 'Select a license end date' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            disabledDate={(current) => current !== null && current < dayjs().startOf('day')}
          />
        </Form.Item>
      )}
    </>
  );
};

export default HostTenantLicenseFields;
